import { ErrorMessage } from '@components/shared/error-message.component';
import { Button, ButtonProps } from '@components/ui/button';
import React from 'react';

const isReactNode = (value: unknown): value is React.ReactNode => {
  return (
    value === null ||
    value === undefined ||
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean' ||
    React.isValidElement(value) ||
    (Array.isArray(value) && value.every(isReactNode))
  );
};

export type ModalFooterProps = {
  errorMessage?: string;
  leftButton?: ButtonProps | React.ReactNode;
  rightButton?: ButtonProps | React.ReactNode;
};

/**
 * Shared modal footer component with standardized button styling
 */
export const ModalFooter: React.FC<ModalFooterProps> = (props) => {
  const { errorMessage, leftButton, rightButton } = props;

  return (
    <div className="w-full mt-auto p-4 border-t border-solid border-gray-300">
      {errorMessage && (
        <div className="flex flex-col items-center justify-center mb-4">
          <ErrorMessage message={errorMessage} />
        </div>
      )}
      <div className="w-full flex justify-between gap-4">
        {leftButton && (
          <div className="w-[40%]">
            {isReactNode(leftButton) ? (
              leftButton
            ) : (
              <Button
                className="w-full"
                variant="secondary"
                {...leftButton}
              />
            )}
          </div>
        )}
        {rightButton && (
          <div className={leftButton ? 'w-[40%] ml-auto' : isReactNode(rightButton) ? 'w-full' : 'w-[40%] ml-auto'}>
            {isReactNode(rightButton) ? (
              rightButton
            ) : (
              <Button
                className="w-full"
                variant="primary"
                {...rightButton}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
